export const STAT_NAMES: {
  [id: string]: string;
} = {
  FIGHT_PROP_HP: "Flat HP",
  FIGHT_PROP_ATTACK: "Flat ATK",
  FIGHT_PROP_DEFENSE: "Flat DEF",
  FIGHT_PROP_HP_PERCENT: "HP%",
  FIGHT_PROP_ATTACK_PERCENT: "ATK%",
  FIGHT_PROP_DEFENSE_PERCENT: "DEF%",
  FIGHT_PROP_CRITICAL: "Crit RATE",
  FIGHT_PROP_CRITICAL_HURT: "Crit DMG",
  FIGHT_PROP_CHARGE_EFFICIENCY: "Energy Recharge",
  FIGHT_PROP_HEAL_ADD: "Healing Bonus",
  FIGHT_PROP_ELEMENT_MASTERY: "Elemental Mastery",
  FIGHT_PROP_PHYSICAL_ADD_HURT: "Physical DMG Bonus",
  FIGHT_PROP_FIRE_ADD_HURT: "Pyro DMG Bonus",
  FIGHT_PROP_ELEC_ADD_HURT: "Electro DMG Bonus",
  FIGHT_PROP_WATER_ADD_HURT: "Hydro DMG Bonus",
  FIGHT_PROP_WIND_ADD_HURT: "Anemo DMG Bonus",
  FIGHT_PROP_ICE_ADD_HURT: "Cryo DMG Bonus",
  FIGHT_PROP_ROCK_ADD_HURT: "Geo DMG Bonus",
  FIGHT_PROP_GRASS_ADD_HURT: "Dendro DMG Bonus",
};

export const REAL_SUBSTAT_VALUES: {
  [id: number]: { value: number; type: string };
} = {
  101021: { value: 23.899999618530273, type: "FIGHT_PROP_HP" },
  101022: { value: 29.8799991607666, type: "FIGHT_PROP_HP" },
  101031: { value: 1.1699999682605267, type: "FIGHT_PROP_HP_PERCENT" },
  101032: { value: 1.4600000344216824, type: "FIGHT_PROP_HP_PERCENT" },
  101051: { value: 1.559999942779541, type: "FIGHT_PROP_ATTACK" },
  101052: { value: 1.9500000476837158, type: "FIGHT_PROP_ATTACK" },
  101061: { value: 1.1699999682605267, type: "FIGHT_PROP_ATTACK_PERCENT" },
  101062: { value: 1.4600000344216824, type: "FIGHT_PROP_ATTACK_PERCENT" },
  101081: { value: 1.850000023841858, type: "FIGHT_PROP_DEFENSE" },
  101082: { value: 2.309999942779541, type: "FIGHT_PROP_DEFENSE" },
  101091: { value: 1.4600000344216824, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  101092: { value: 1.8200000748038292, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  101201: { value: 0.7799999788403511, type: "FIGHT_PROP_CRITICAL" },
  101202: { value: 0.9700000286102295, type: "FIGHT_PROP_CRITICAL" },
  101221: { value: 1.549999974668026, type: "FIGHT_PROP_CRITICAL_HURT" },
  101222: { value: 1.940000057220459, type: "FIGHT_PROP_CRITICAL_HURT" },
  101231: { value: 1.3000000268220901, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  101232: { value: 1.6200000420212746, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  101241: { value: 4.659999847412109, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  101242: { value: 5.829999923706055, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  201021: { value: 50.189998626708984, type: "FIGHT_PROP_HP" },
  201022: { value: 60.95000076293945, type: "FIGHT_PROP_HP" },
  201023: { value: 71.69999694824219, type: "FIGHT_PROP_HP" },
  201031: { value: 1.6300000250339508, type: "FIGHT_PROP_HP_PERCENT" },
  201032: { value: 1.979999989271164, type: "FIGHT_PROP_HP_PERCENT" },
  201033: { value: 2.329999953508377, type: "FIGHT_PROP_HP_PERCENT" },
  201051: { value: 3.2699999809265137, type: "FIGHT_PROP_ATTACK" },
  201052: { value: 3.9700000286102295, type: "FIGHT_PROP_ATTACK" },
  201053: { value: 4.670000076293945, type: "FIGHT_PROP_ATTACK" },
  201061: { value: 1.6300000250339508, type: "FIGHT_PROP_ATTACK_PERCENT" },
  201062: { value: 1.979999989271164, type: "FIGHT_PROP_ATTACK_PERCENT" },
  201063: { value: 2.329999953508377, type: "FIGHT_PROP_ATTACK_PERCENT" },
  201081: { value: 3.890000104904175, type: "FIGHT_PROP_DEFENSE" },
  201082: { value: 4.71999979019165, type: "FIGHT_PROP_DEFENSE" },
  201083: { value: 5.559999942779541, type: "FIGHT_PROP_DEFENSE" },
  201091: { value: 2.0400000736117363, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  201092: { value: 2.4800000712275505, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  201093: { value: 2.9100000858306885, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  201201: { value: 1.0900000110268593, type: "FIGHT_PROP_CRITICAL" },
  201202: { value: 1.3199999928474426, type: "FIGHT_PROP_CRITICAL" },
  201203: { value: 1.549999974668026, type: "FIGHT_PROP_CRITICAL" },
  201221: { value: 2.1800000220537186, type: "FIGHT_PROP_CRITICAL_HURT" },
  201222: { value: 2.6399999856948853, type: "FIGHT_PROP_CRITICAL_HURT" },
  201223: { value: 3.109999932348728, type: "FIGHT_PROP_CRITICAL_HURT" },
  201231: { value: 1.810000091791153, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  201232: { value: 2.199999988079071, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  201233: { value: 2.590000070631504, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  201241: { value: 6.53000020980835, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  201242: { value: 7.929999828338623, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  201243: { value: 9.329999923706055, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  301021: { value: 100.37999725341797, type: "FIGHT_PROP_HP" },
  301022: { value: 114.72000122070312, type: "FIGHT_PROP_HP" },
  301023: { value: 129.05999755859375, type: "FIGHT_PROP_HP" },
  301024: { value: 143.39999389648438, type: "FIGHT_PROP_HP" },
  301031: { value: 2.449999935925007, type: "FIGHT_PROP_HP_PERCENT" },
  301032: { value: 2.800000086426735, type: "FIGHT_PROP_HP_PERCENT" },
  301033: { value: 3.150000050663948, type: "FIGHT_PROP_HP_PERCENT" },
  301034: { value: 3.500000014901161, type: "FIGHT_PROP_HP_PERCENT" },
  301051: { value: 6.539999961853027, type: "FIGHT_PROP_ATTACK" },
  301052: { value: 7.46999979019165, type: "FIGHT_PROP_ATTACK" },
  301053: { value: 8.399999618530273, type: "FIGHT_PROP_ATTACK" },
  301054: { value: 9.34000015258789, type: "FIGHT_PROP_ATTACK" },
  301061: { value: 2.449999935925007, type: "FIGHT_PROP_ATTACK_PERCENT" },
  301062: { value: 2.800000086426735, type: "FIGHT_PROP_ATTACK_PERCENT" },
  301063: { value: 3.150000050663948, type: "FIGHT_PROP_ATTACK_PERCENT" },
  301064: { value: 3.500000014901161, type: "FIGHT_PROP_ATTACK_PERCENT" },
  301081: { value: 7.78000020980835, type: "FIGHT_PROP_DEFENSE" },
  301082: { value: 8.890000343322754, type: "FIGHT_PROP_DEFENSE" },
  301083: { value: 10, type: "FIGHT_PROP_DEFENSE" },
  301084: { value: 11.109999656677246, type: "FIGHT_PROP_DEFENSE" },
  301091: { value: 3.060000017285347, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  301092: { value: 3.500000014901161, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  301093: { value: 3.9299998432397842, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  301094: { value: 4.3699998408555984, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  301201: { value: 1.6300000250339508, type: "FIGHT_PROP_CRITICAL" },
  301202: { value: 1.8600000068545341, type: "FIGHT_PROP_CRITICAL" },
  301203: { value: 2.0999999716877937, type: "FIGHT_PROP_CRITICAL" },
  301204: { value: 2.329999953508377, type: "FIGHT_PROP_CRITICAL" },
  301221: { value: 3.2600000500679016, type: "FIGHT_PROP_CRITICAL_HURT" },
  301222: { value: 3.7300001829862595, type: "FIGHT_PROP_CRITICAL_HURT" },
  301223: { value: 4.1999999433755875, type: "FIGHT_PROP_CRITICAL_HURT" },
  301224: { value: 4.659999907016754, type: "FIGHT_PROP_CRITICAL_HURT" },
  301231: { value: 2.72000003606081, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  301232: { value: 3.109999932348728, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  301233: { value: 3.500000014901161, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  301234: { value: 3.8899999111890793, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  301241: { value: 9.789999961853027, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  301242: { value: 11.1899995803833, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  301243: { value: 12.59000015258789, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  301244: { value: 13.989999771118164, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  401021: { value: 167.3000030517578, type: "FIGHT_PROP_HP" },
  401022: { value: 191.1999969482422, type: "FIGHT_PROP_HP" },
  401023: { value: 215.10000610351562, type: "FIGHT_PROP_HP" },
  401024: { value: 239, type: "FIGHT_PROP_HP" },
  401031: { value: 3.2600000500679016, type: "FIGHT_PROP_HP_PERCENT" },
  401032: { value: 3.7300001829862595, type: "FIGHT_PROP_HP_PERCENT" },
  401033: { value: 4.1999999433755875, type: "FIGHT_PROP_HP_PERCENT" },
  401034: { value: 4.659999907016754, type: "FIGHT_PROP_HP_PERCENT" },
  401051: { value: 10.890000343322754, type: "FIGHT_PROP_ATTACK" },
  401052: { value: 12.449999809265137, type: "FIGHT_PROP_ATTACK" },
  401053: { value: 14, type: "FIGHT_PROP_ATTACK" },
  401054: { value: 15.5600004196167, type: "FIGHT_PROP_ATTACK" },
  401061: { value: 3.2600000500679016, type: "FIGHT_PROP_ATTACK_PERCENT" },
  401062: { value: 3.7300001829862595, type: "FIGHT_PROP_ATTACK_PERCENT" },
  401063: { value: 4.1999999433755875, type: "FIGHT_PROP_ATTACK_PERCENT" },
  401064: { value: 4.659999907016754, type: "FIGHT_PROP_ATTACK_PERCENT" },
  401081: { value: 12.960000038146973, type: "FIGHT_PROP_DEFENSE" },
  401082: { value: 14.819999694824219, type: "FIGHT_PROP_DEFENSE" },
  401083: { value: 16.670000076293945, type: "FIGHT_PROP_DEFENSE" },
  401084: { value: 18.520000457763672, type: "FIGHT_PROP_DEFENSE" },
  401091: { value: 4.080000147223473, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  401092: { value: 4.659999907016754, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  401093: { value: 5.249999836087227, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  401094: { value: 5.829999968409538, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  401201: { value: 2.1800000220537186, type: "FIGHT_PROP_CRITICAL" },
  401202: { value: 2.4900000542402267, type: "FIGHT_PROP_CRITICAL" },
  401203: { value: 2.800000086426735, type: "FIGHT_PROP_CRITICAL" },
  401204: { value: 3.109999932348728, type: "FIGHT_PROP_CRITICAL" },
  401221: { value: 4.349999874830246, type: "FIGHT_PROP_CRITICAL_HURT" },
  401222: { value: 4.969999939203262, type: "FIGHT_PROP_CRITICAL_HURT" },
  401223: { value: 5.60000017285347, type: "FIGHT_PROP_CRITICAL_HURT" },
  401224: { value: 6.219999864697456, type: "FIGHT_PROP_CRITICAL_HURT" },
  401231: { value: 3.6299999803304672, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  401232: { value: 4.14000004529953, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  401233: { value: 4.659999907016754, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  401234: { value: 5.180000141263008, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  401241: { value: 13.0600004196167, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  401242: { value: 14.920000076293945, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  401243: { value: 16.790000915527344, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  401244: { value: 18.649999618530273, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  501021: { value: 209.1300048828125, type: "FIGHT_PROP_HP" },
  501022: { value: 239, type: "FIGHT_PROP_HP" },
  501023: { value: 268.8800048828125, type: "FIGHT_PROP_HP" },
  501024: { value: 298.75, type: "FIGHT_PROP_HP" },
  501031: { value: 4.080000147223473, type: "FIGHT_PROP_HP_PERCENT" },
  501032: { value: 4.659999907016754, type: "FIGHT_PROP_HP_PERCENT" },
  501033: { value: 5.249999836087227, type: "FIGHT_PROP_HP_PERCENT" },
  501034: { value: 5.829999968409538, type: "FIGHT_PROP_HP_PERCENT" },
  501051: { value: 13.619999885559082, type: "FIGHT_PROP_ATTACK" },
  501052: { value: 15.5600004196167, type: "FIGHT_PROP_ATTACK" },
  501053: { value: 17.510000228881836, type: "FIGHT_PROP_ATTACK" },
  501054: { value: 19.450000762939453, type: "FIGHT_PROP_ATTACK" },
  501061: { value: 4.080000147223473, type: "FIGHT_PROP_ATTACK_PERCENT" },
  501062: { value: 4.659999907016754, type: "FIGHT_PROP_ATTACK_PERCENT" },
  501063: { value: 5.249999836087227, type: "FIGHT_PROP_ATTACK_PERCENT" },
  501064: { value: 5.829999968409538, type: "FIGHT_PROP_ATTACK_PERCENT" },
  501081: { value: 16.200000762939453, type: "FIGHT_PROP_DEFENSE" },
  501082: { value: 18.520000457763672, type: "FIGHT_PROP_DEFENSE" },
  501083: { value: 20.829999923706055, type: "FIGHT_PROP_DEFENSE" },
  501084: { value: 23.149999618530273, type: "FIGHT_PROP_DEFENSE" },
  501091: { value: 5.099999904632568, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  501092: { value: 5.829999968409538, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  501093: { value: 6.560000032186508, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  501094: { value: 7.289999723434448, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  501201: { value: 2.72000003606081, type: "FIGHT_PROP_CRITICAL" },
  501202: { value: 3.109999932348728, type: "FIGHT_PROP_CRITICAL" },
  501203: { value: 3.500000014901161, type: "FIGHT_PROP_CRITICAL" },
  501204: { value: 3.8899999111890793, type: "FIGHT_PROP_CRITICAL" },
  501221: { value: 5.44000007212162, type: "FIGHT_PROP_CRITICAL_HURT" },
  501222: { value: 6.219999864697456, type: "FIGHT_PROP_CRITICAL_HURT" },
  501223: { value: 6.989999860525131, type: "FIGHT_PROP_CRITICAL_HURT" },
  501224: { value: 7.769999653100967, type: "FIGHT_PROP_CRITICAL_HURT" },
  501231: { value: 4.529999941587448, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  501232: { value: 5.180000141263008, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  501233: { value: 5.829999968409538, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  501234: { value: 6.480000168085098, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  501241: { value: 16.31999969482422, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  501242: { value: 18.649999618530273, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  501243: { value: 20.979999542236328, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  501244: { value: 23.309999465942383, type: "FIGHT_PROP_ELEMENT_MASTERY" },
  //
  // KQM
  // 900000 - 900009
  //
  900000: { value: 253.94, type: "FIGHT_PROP_HP" },
  900001: { value: 16.54, type: "FIGHT_PROP_ATTACK" },
  900002: { value: 19.68, type: "FIGHT_PROP_DEFENSE" },
  900003: { value: 4.96, type: "FIGHT_PROP_HP_PERCENT" },
  900004: { value: 4.96, type: "FIGHT_PROP_ATTACK_PERCENT" },
  900005: { value: 6.2, type: "FIGHT_PROP_DEFENSE_PERCENT" },
  900006: { value: 3.31, type: "FIGHT_PROP_CRITICAL" },
  900007: { value: 6.62, type: "FIGHT_PROP_CRITICAL_HURT" },
  900008: { value: 5.51, type: "FIGHT_PROP_CHARGE_EFFICIENCY" },
  900009: { value: 19.82, type: "FIGHT_PROP_ELEMENT_MASTERY" },
};

export const roundToFixed = (n: number | string, decimals: number) => {
  const multiplier = 10 ** decimals;
  return Math.round(+n * multiplier) / multiplier;
};

export const ROUNDED_REAL_SUBSTAT_VALUES: {
  [id: number]: { value: number; type: string };
} = Object.keys(REAL_SUBSTAT_VALUES).reduce((acc: any, key: any) => {
  const multiplier = 1000000;
  const roundedVal = roundToFixed(
    roundToFixed(REAL_SUBSTAT_VALUES[key].value * multiplier, 0) / multiplier,
    4
  );

  acc[key] = {
    type: REAL_SUBSTAT_VALUES[key].type,
    value: roundedVal,
  };
  return acc;
}, {});

export const MAX_ROLLS = Object.keys(STAT_NAMES).reduce((acc: any, val) => {
  const allPossibleRolls = Object.values(ROUNDED_REAL_SUBSTAT_VALUES).filter(
    (x) => x.type === val
  );
  const highestPossibleRoll = Math.max(
    ...Object.values(allPossibleRolls).map((o) => o.value)
  );

  const key = STAT_NAMES[val];
  return {
    ...acc,
    [key]: highestPossibleRoll,
  };
}, {});

export const getSubstatEfficiency = (value: number, key: string) => {
  const max = MAX_ROLLS[key];
  return Math.round((value / max) * 20) * 5;
};

export const fixCritValue = (row: any) => {
  if (!row.substatsIdList) {
    // return +(+(row.critValue * 100).toFixed(0) / 10).toFixed(0) / 10;
    return roundToFixed(row.critValue, 1);
  }

  let critValue = 0;

  row.substatsIdList.forEach((id: number) => {
    if (REAL_SUBSTAT_VALUES[id].type === "FIGHT_PROP_CRITICAL") {
      critValue += 2 * ROUNDED_REAL_SUBSTAT_VALUES[id].value;
    } else if (REAL_SUBSTAT_VALUES[id].type === "FIGHT_PROP_CRITICAL_HURT") {
      critValue += ROUNDED_REAL_SUBSTAT_VALUES[id].value;
    }
  });

  // return +(critValue * 10).toFixed(0) / 10;
  return roundToFixed(critValue, 1);
};
